<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import flashMessage from "../../components/flashMessahe";
import ErrorMessage from "../../components/error-message";
import { ModelSelect } from 'vue-search-select';
import {
  required,
  email,
  minLength,
  sameAs,
  maxLength,
  minValue,
  maxValue,
  numeric,
  url,
  alphaNum,
} from "vuelidate/lib/validators";

export default {
  components: {
      ErrorMessage,
    Layout,
    PageHeader,
    flashMessage,
      ModelSelect
  },
  data() {
    return {
      errorMessage: "",
      title: "Sub Agent Create",
      items: [
        {
          text: "Agent",
          href: "/",
        },
        {
          text: "Sub Agent Create",
          active: true,
        },
      ],
      status: "not_accepted",
      checkCustom: "not_accepted",
      checked: false,
      errors: null,
        visible:false,
        message:"",
        agencies:"",
        country_list:[],
      form: {
        first_name: "",
        last_name: "",
        gender: "",
        email: "",
        country_code: "",
        country: "",
        phone_code: "",
        phone_number: "",
        city: "",
        postal_code: "",
        address: "",
          password:"",
          password_confirmation:"",
        markup_amount: "",
        markup_type: "",
        file: "",
        filename: "",
        currency: "",
        language: "",
        agency_uuid: "",
      },
      submitform: false,
      submitted: false,
    };
  },
  validations: {
    form: {
      first_name: {
        required,
      },
      last_name: {
        required,
      },
      gender: {
        required,
      },
      email: {
        required,
      },
      country_code: {
        required,
      },
      country: {
        required,
      },
      phone_code: {
        required,
      },
      phone_number: {
        required,
      },
      city: {
        required,
      },
      address: {
        required,
      },
      postal_code: {
        required,
      },
        password: {
          required,
        },
        password_confirmation: {
          required,
        },
      markup_amount: {
        required,
      },
      markup_type: {
        required,
      },
      currency: {
        required,
      },
      language: {
        required,
      },
      agency_uuid: {
        required,
      },
    },
  },
    mounted() {
        this.getSubAgentList();
        this.getCountryList();
    },
  methods: {
      onClose(){
          this.visible=false;
      },
      setCountryAndPhoneCode(event){
          let countries=this.country_list
          let i;
          for(i=0;i<countries.length;i++){
              if(countries[i].countryName==event){
                  this.form.country_code=countries[i].countryCode;
                  this.form.phone_code=countries[i].phoneCode;
              }
          }
      },
      setPhoneCodeAndCountry(event){
          let countries=this.country_list
          let i;
          for(i=0;i<countries.length;i++){
              if(countries[i].phoneCode==event.target.value){
                  this.form.country=countries[i].countryName;
                  this.form.phone_code=countries[i].phoneCode;
              }
          }
      },
      async getCountryList() {
          try {
              axios
                  .get("/api/country/list", {
                      params: {
                          accessToken: localStorage.getItem("access_tocken"),
                      },
                  })
                  .then((response) => {
                      if (response.status) {
                          this.country_list=response.data.data;
                          let ar=[];
                          let i;
                          let temp=response.data.data;
                          for (i=0;i<temp.length;i++){
                              temp[i].value = temp[i].countryName;
                              temp[i].text = temp[i].countryName;
                              ar.push(temp[i]);
                          }
                          this.country_list=ar;
                      } else {
                          var str = response.data.message;
                          var jsonParse = JSON.parse(str);
                          this.errorCheck(jsonParse);
                      }
                  })
                  .catch((error) => {
                      console.log(error.message);
                  });
          } catch (err) {
              console.log(err);
          }
      },
      async getSubAgentList() {
          try {
              axios
                  .get("/api/agency-information/list", {
                      params: {
                          accessToken: localStorage.getItem("access_tocken"),
                      },
                  })
                  .then((response) => {
                      if (response.data.status) {
                          this.agencies = response.data.data;
                      } else {
                          var str = response.data.message;
                          var jsonParse = JSON.parse(str);
                          this.errorCheck(jsonParse);
                      }
                  })
                  .catch((error) => {
                      console.log(error.message);
                  });
          } catch (err) {
              console.log(err);
          }
      },

    formSubmit(event) {
        this.submitted = true;
        this.$v.$touch();
        axios
            .post("/api/sub-agent/create", {
                first_name: this.form.first_name,
                last_name: this.form.last_name,
                gender:this.form.gender,
                email:this.form.email,
                country_code:this.form.country_code,
                country:this.form.country,
                phone_code:this.form.phone_code,
                phone_number:this.form.phone_number,
                city:this.form.city,
                address:this.form.address,
                postal_code:this.form.postal_code,
                markup_amount:this.form.markup_amount,
                markup_type:this.form.markup_type,
                password:this.form.password,
                password_confirmation:this.form.password_confirmation,
                currency:this.form.currency,
                language:this.form.language,
                agency_uuid:this.form.agency_uuid,
                accessToken: localStorage.getItem("access_tocken"),
            })
            .then((response) => {
                if (response.data.status) {
                    this.$refs.subAgentForm.reset();
                    this.$swal("Good job!", "Sub Agent Created", "success");
                    this.$router.push({ name: "sub_agent_list" });
                } else {
                    var str = response.data.message;
                    var jsonParse = JSON.parse(str);
                    this.errorCheck(jsonParse);
                }
            })
            .catch((error) => {
                if (error.response != undefined) {
                    this.errors = error.response.data.errors;
                }
            });
    },
      applySameDataAsAgent(event){
          if (event.target.checked==true){
              this.form.agency_country=this.form.country;
              this.form.agency_city=this.form.city;
              this.form.agency_postal_code=this.form.postal_code;
              this.form.agency_address=this.form.address;
          }
      },
    errorCheck(obj) {
        if(obj.statusCode == 403){
            this.visible=true;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if (obj.error) {
        this.errors = obj.message;
      } else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (
        obj.message !== "Token has expired" &&
        obj.message !== "The given data was invalid."
      ) {
        this.errors = obj.message;
      } else if (obj.message == "The given data was invalid.") {
        this.errors = obj.errors;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data save",
        });
      }
    },
    resetForm(event) {
      console.log("Reseting the form");
      event.target.reset();
    },
    passwordEyeToggle() {
      var x = document.getElementById("password");
      var y = document.getElementById("eye-1");
      var z = document.getElementById("eye-2");

      if(x.type === "password"){
        x.type = "text";
        y.style.display = "block";
        z.style.display = "none";
      }
      else{
        x.type = "password";
        y.style.display = "none";
        z.style.display = "block";
      }
    },
    confirmPasswordEyeToggle() {
      var x = document.getElementById("password_confirmation");
      var y = document.getElementById("eye-3");
      var z = document.getElementById("eye-4");

      if(x.type === "password"){
        x.type = "text";
        y.style.display = "block";
        z.style.display = "none";
      }
      else{
        x.type = "password";
        y.style.display = "none";
        z.style.display = "block";
      }
    },
  },
};
</script>

<template>
  <Layout>
    <flashMessage/>
    <PageHeader :title="title" :items="items" />
      <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
    <div class="row">
      <div class="col-lg-12 col-sm-12">
        <div class="card">
          <div class="card-body">
            <div v-if="errors" class="font-bold mb-4 ">
              <div v-for="(v, k) in errors" :key="k">
                <p v-for="error in v" :key="error" class="text-sm">
                  {{ error }}
                </p>
              </div>
            </div>
            <form ref="subAgentForm" @submit.prevent="formSubmit" class="needs-validation">
              <div class="card">
                  <div class="card-body">
                      <h4 class="card-title mb-4 alert alert-success"><i class="bx bx-time-five"></i>Sub Agent Information</h4>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group">
                            <label class="required" for="first_name">First Name</label>
                            <input
                              id="first_name"
                              v-model="form.first_name"
                              name="first_name"
                              type="text"
                              class="form-control"
                              placeholder="Type First Name"
                              value
                              :class="{ 'is-invalid': submitted && $v.form.first_name.$error }"
                            />
                            <div
                              v-if="submitted && $v.form.first_name.$error"
                              class="invalid-feedback"
                            >
                              <span v-if="!$v.form.first_name.required">This value is required.</span>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label class="required" for="last_name">Last Name</label>
                            <input
                              id="last_name"
                              v-model="form.last_name"
                              name="last_name"
                              type="text"
                              class="form-control"
                              placeholder="Type Last Name"
                              value
                              :class="{ 'is-invalid': submitted && $v.form.last_name.$error }"
                            />
                            <div
                              v-if="submitted && $v.form.last_name.$error"
                              class="invalid-feedback"
                            >
                              <span v-if="!$v.form.last_name.required">This value is required.</span>
                            </div>
                          </div>
                        </div>

                        <div class="col-md-6">
                          <div class="form-group">
                            <label class="required" for="gender">Gender</label>
                            <select
                              id="gender"
                              name="gender"
                              v-model="form.gender"
                              type="text"
                              class="form-control"
                              placeholder="Type Gender"
                              value
                              :class="{ 'is-invalid': submitted && $v.form.gender.$error }">
                                <option value="" disabled style="display:none" selected>Select Gender</option>a
                              <option value="male">Male</option>
                              <option value="female">Female</option>
                            </select>
                            <div
                              v-if="submitted && $v.form.gender.$error"
                              class="invalid-feedback"
                            >
                              <span v-if="!$v.form.gender.required">This value is required.</span>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label class="required" for="email">Email</label>
                            <input
                              id="email"
                              v-model="form.email"
                              name="email"
                              type="email"
                              class="form-control"
                              placeholder="Type Email"
                              value
                              :class="{ 'is-invalid': submitted && $v.form.email.$error }"
                            />
                            <div
                              v-if="submitted && $v.form.email.$error"
                              class="invalid-feedback"
                            >
                              <span v-if="!$v.form.email.required">This value is required.</span>
                            </div>
                          </div>
                        </div>
                          <div class="col-md-6">
                              <div class="form-group">
                                  <label>Select Country</label>
                                  <model-select :options="country_list"
                                                v-model="form.country"
                                                @input="setCountryAndPhoneCode"
                                                placeholder="Select Country">
                                  </model-select>
                              </div>
                          </div>
<!--                          <div class="col-md-6">-->
<!--                              <div class="form-group">-->
<!--                                  <label class="required" for="country">Country</label>-->
<!--                                  <select-->
<!--                                      id="country"-->
<!--                                      name="country"-->
<!--                                      v-model="form.country"-->
<!--                                      v-on:change="setCountryAndPhoneCode"-->
<!--                                      type="text"-->
<!--                                      class="form-control"-->
<!--                                      placeholder="Select Country"-->
<!--                                      value-->
<!--                                      :class="{ 'is-invalid': submitted && $v.form.country.$error }">-->
<!--                                      <option value="" disabled style="display:none" selected>Select Country</option>a-->
<!--                                      <option v-for="(country, index) in country_list" :value="country.countryName"-->
<!--                                              v-bind:key="index">{{ country.countryName}}-->
<!--                                      </option>-->
<!--                                  </select>-->
<!--                                  <div-->
<!--                                      v-if="submitted && $v.form.country.$error"-->
<!--                                      class="invalid-feedback"-->
<!--                                  >-->
<!--                                      <span v-if="!$v.form.country.required">This value is required.</span>-->
<!--                                  </div>-->
<!--                              </div>-->
<!--                          </div>-->
<!--                        <div class="col-md-6">-->
<!--                            <div class="form-group">-->
<!--                                <label class="required" for="country_code">Country Code</label>-->
<!--                                <select-->
<!--                                    id="country_code"-->
<!--                                    name="country_code"-->
<!--                                    v-model="form.country_code"-->
<!--                                    type="text"-->
<!--                                    class="form-control"-->
<!--                                    placeholder="Type Country Code"-->
<!--                                    value-->
<!--                                    :class="{ 'is-invalid': submitted && $v.form.country_code.$error }">-->
<!--                                    <option value="" disabled style="display:none" selected>Select Country Code</option>a-->
<!--                                    <option v-for="(country, index) in country_list" :value="country.countryCode"-->
<!--                                            v-bind:key="index">{{ country.countryCode }}-->
<!--                                    </option>-->
<!--                                </select>-->
<!--                                <div-->
<!--                                    v-if="submitted && $v.form.country_code.$error"-->
<!--                                    class="invalid-feedback"-->
<!--                                >-->
<!--                                    <span v-if="!$v.form.country_code.required">This value is required.</span>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="required" for="phone_code">Phone Code</label>
                                <select
                                    id="phone_code"
                                    name="phone_code"
                                    v-model="form.phone_code"
                                    v-on:change="setPhoneCodeAndCountry"
                                    type="text"
                                    class="form-control"
                                    placeholder="Select Phone Code"
                                    value
                                    :class="{ 'is-invalid': submitted && $v.form.phone_code.$error }">
                                    <option value="" disabled style="display:none" selected>Select Phone Code</option>a
                                    <option v-for="(country, index) in country_list" :value="country.phoneCode"
                                            v-bind:key="index">{{ country.phoneCode }}
                                    </option>
                                </select>
                                <div
                                    v-if="submitted && $v.form.phone_code.$error"
                                    class="invalid-feedback"
                                >
                                    <span v-if="!$v.form.phone_code.required">This value is required.</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label class="required" for="phone_number">Phone Number</label>
                            <input
                              id="phone_number"
                              v-model="form.phone_number"
                              name="phone_number"
                              type="text"
                              class="form-control"
                              placeholder="Type Phone Number"
                              value
                              :class="{ 'is-invalid': submitted && $v.form.phone_number.$error }"
                            >
                            <div
                              v-if="submitted && $v.form.phone_number.$error"
                              class="invalid-feedback"
                            >
                              <span v-if="!$v.form.phone_number.required">This value is required.</span>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label class="required" for="currency">Currency</label>
                            <input
                              id="currency"
                              v-model="form.currency"
                              name="currency"
                              type="text"
                              class="form-control"
                              placeholder="Type Currency"
                              value
                              :class="{ 'is-invalid': submitted && $v.form.currency.$error }"
                            >
                            <div
                              v-if="submitted && $v.form.currency.$error"
                              class="invalid-feedback"
                            >
                              <span v-if="!$v.form.currency.required">This value is required.</span>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label class="required" for="language">Language</label>
                            <input
                              id="language"
                              v-model="form.language"
                              name="language"
                              type="text"
                              class="form-control"
                              placeholder="Type Language"
                              value
                              :class="{ 'is-invalid': submitted && $v.form.language.$error }"
                            >
                            <div
                              v-if="submitted && $v.form.language.$error"
                              class="invalid-feedback"
                            >
                              <span v-if="!$v.form.language.required">This value is required.</span>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label class="required" for="city">City</label>
                            <input
                              id="city"
                              v-model="form.city"
                              name="city"
                              type="text"
                              class="form-control"
                              placeholder="Type City"
                              value
                              :class="{ 'is-invalid': submitted && $v.form.city.$error }"
                            >
                            <div
                              v-if="submitted && $v.form.city.$error"
                              class="invalid-feedback"
                            >
                              <span v-if="!$v.form.city.required">This value is required.</span>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label class="required" for="postal_code">Postal Code</label>
                            <input
                              id="postal_code"
                              v-model="form.postal_code"
                              name="postal_code"
                              type="text"
                              class="form-control"
                              placeholder="Type Postal Code"
                              value
                              :class="{ 'is-invalid': submitted && $v.form.postal_code.$error }"
                            >
                            <div
                              v-if="submitted && $v.form.postal_code.$error"
                              class="invalid-feedback"
                            >
                              <span v-if="!$v.form.postal_code.required">This value is required.</span>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label class="required" for="address">Address</label>
                            <textarea
                              id="address"
                              v-model="form.address"
                              name="address"
                              type="text"
                              class="form-control"
                              placeholder="Type Address"
                              value
                              :class="{ 'is-invalid': submitted && $v.form.address.$error }"
                            >
                            </textarea>
                            <div
                              v-if="submitted && $v.form.address.$error"
                              class="invalid-feedback"
                            >
                              <span v-if="!$v.form.address.required">This value is required.</span>
                            </div>
                          </div>
                        </div>

                        <div class="col-md-6">
                          <div class="form-group">
                            <label for="markup_amount">Markup Amount</label>
                            <input
                              id="markup_amount"
                              v-model="form.markup_amount"
                              name="markup_amount"
                              type="text"
                              class="form-control"
                              placeholder="Type Markup Amount"
                            />
<!--                            <div-->
<!--                              v-if="submitted && $v.form.markup_amount.$error"-->
<!--                              class="invalid-feedback"-->
<!--                            >-->
<!--                              <span v-if="!$v.form.markup_amount.required">This value is required.</span>-->
<!--                            </div>-->
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label for="markup_type">Markup Type</label>
                            <select
                              id="markup_type"
                              name="markup_type"
                              v-model="form.markup_type"
                              type="text"
                              class="form-control"
                              placeholder="Type markup type"
                            >
                                <option value="" disabled style="display:none" selected>Select Markup Type</option>a
                              <option value="flat">flat</option>
                              <option value="percentage">Percentage</option>
                            </select>
<!--                            <div-->
<!--                              v-if="submitted && $v.form.markup_type.$error"-->
<!--                              class="invalid-feedback"-->
<!--                            >-->
<!--                              <span v-if="!$v.form.markup_type.required">This value is required.</span>-->
<!--                            </div>-->
                          </div>
                        </div>
                          <div class="col-md-6">
                              <div class="form-group">
                                  <label class="required" for="password">Passowrd</label>
                                  <input
                                      id="password"
                                      v-model="form.password"
                                      name="password"
                                      type="password"
                                      class="form-control"
                                      placeholder="Type Passowrd"
                                      value
                                      :class="{ 'is-invalid': submitted && $v.form.password.$error }"
                                  />
                                  <span class="eye" >
                                    <i class="fa fa-eye" aria-hidden="true" @click="passwordEyeToggle()" id="eye-1"> </i>
                                    <i class="fa fa-eye-slash" aria-hidden="true" @click="passwordEyeToggle()" id="eye-2"> </i>
                                  </span>
                                  <div
                                      v-if="submitted && $v.form.password.$error"
                                      class="invalid-feedback"
                                  >
                                      <span v-if="!$v.form.password.required">This value is required.</span>
                                  </div>
                              </div>
                          </div>
                          <div class="col-md-6">
                              <div class="form-group">
                                  <label class="required" for="password_confirmation">Confirm Password</label>
                                  <input
                                      id="password_confirmation"
                                      v-model="form.password_confirmation"
                                      name="password_confirmation"
                                      type="password"
                                      class="form-control"
                                      placeholder="Confirm Password"
                                      value
                                      :class="{ 'is-invalid': submitted && $v.form.password_confirmation.$error }"
                                  />
                                  <span class="eye" >
                                    <i class="fa fa-eye" aria-hidden="true" @click="confirmPasswordEyeToggle()" id="eye-3"> </i>
                                    <i class="fa fa-eye-slash" aria-hidden="true" @click="confirmPasswordEyeToggle()" id="eye-4"> </i>
                                  </span>
                                  <div
                                      v-if="submitted && $v.form.password_confirmation.$error"
                                      class="invalid-feedback"
                                  >
                                      <span v-if="!$v.form.password_confirmation.required">This value is required.</span>
                                  </div>
                              </div>
                          </div>
                          <div class="col-md-6">
                              <div class="form-group">
                                  <label class="required" for="agency_uuid">Agency</label>
                                  <select
                                      id="agency_uuid"
                                      name="user_role_id"
                                      v-model="form.agency_uuid"
                                      class="form-control"
                                      :class="{ 'is-invalid': submitted && $v.form.agency_uuid.$error }"
                                  >
                                      <option value="null">All</option>
                                      <option v-for="(agency, index) in agencies" :value="agency.uuid"
                                              v-bind:key="index">{{ agency.agency_name+" ,"+agency.address+" ,"+agency.city+" ,"+agency.country}}
                                      </option>
                                  </select>
                                  <div
                                      v-if="submitted && $v.form.agency_uuid.$error"
                                      class="invalid-feedback"
                                  >
                                      <span v-if="!$v.form.agency_uuid.required">This value is required.</span>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>

              <button class="btn btn-primary" type="submit">Submit</button>
            </form>
          </div>
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>


<style>
  .eye{
    display: flex;
    position: absolute;
    right: 20px;
    top: 40px;
  }
  .eye:hover{
    box-shadow: 30px;
    cursor: pointer;
  }
  #eye-1, #eye-3{
    display: none;
  }

</style>
